import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import CoursesManager from './components/CoursesManager';
import LeadersManager from './components/LeadersManager';
import PlacementsManager from './components/PlacementsManager';
import GalleryManager from './components/GalleryManager';
import ContactsManager from './components/ContactsManager';
import RecruitersManager from './components/RecruitersManager';
import UsersManager from './components/UsersManager';
import CourseEnrollmentsManager from './components/CourseEnrollmentsManager';

// Navigation component with active link highlighting
const Navigation = ({ admin, onLogout }) => {
  const location = useLocation();
  
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <nav className="admin-nav">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/">
            <div className="logo-wrapper">
              <svg className="nav-logo" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="brand-text">AV Tech Admin</span>
            </div>
          </Link>
        </div>
        <div className="nav-links">
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            Dashboard
          </Link>
          <Link to="/users" className={`nav-link ${isActive('/users') ? 'active' : ''}`}>
            Users
          </Link>
          <Link to="/enrollments" className={`nav-link ${isActive('/enrollments') ? 'active' : ''}`}>
            Enrollments
          </Link>
          {/* <Link to="/courses" className={`nav-link ${isActive('/courses') ? 'active' : ''}`}>
            Courses
          </Link>
          <Link to="/leaders" className={`nav-link ${isActive('/leaders') ? 'active' : ''}`}>
            Leadership
          </Link>
          <Link to="/placements" className={`nav-link ${isActive('/placements') ? 'active' : ''}`}>
            Placements
          </Link> */}
          <Link to="/gallery" className={`nav-link ${isActive('/gallery') ? 'active' : ''}`}>
            Gallery
          </Link>
          <Link to="/contacts" className={`nav-link ${isActive('/contacts') ? 'active' : ''}`}>
            Contacts
          </Link>
          <Link to="/recruiters" className={`nav-link ${isActive('/recruiters') ? 'active' : ''}`}>
            Recruiters
          </Link>
        </div>
        <div className="nav-user">
          <span className="user-name">{admin?.username || 'Admin'}</span>
          <button onClick={onLogout} className="logout-btn">Logout</button>
        </div>
      </div>
    </nav>
  );
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const adminData = localStorage.getItem('admin');
    if (token && adminData) {
      setIsAuthenticated(true);
      setAdmin(JSON.parse(adminData));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('admin');
    setIsAuthenticated(false);
    setAdmin(null);
    toast.success('Logged out successfully');
  };

  if (!isAuthenticated) {
    return (
      <>
        <ToastContainer position="top-right" autoClose={3000} />
        <Login onLogin={setIsAuthenticated} />
      </>
    );
  }

  return (
    <Router>
      <div className="app">
        <Navigation admin={admin} onLogout={handleLogout} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/users" element={<UsersManager />} />
            <Route path="/enrollments" element={<CourseEnrollmentsManager />} />
            <Route path="/courses" element={<CoursesManager />} />
            <Route path="/leaders" element={<LeadersManager />} />
            <Route path="/placements" element={<PlacementsManager />} />
            <Route path="/gallery" element={<GalleryManager />} />
            <Route path="/contacts" element={<ContactsManager />} />
            <Route path="/recruiters" element={<RecruitersManager />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>
        <ToastContainer position="top-right" autoClose={3000} />
      </div>
    </Router>
  );
}

export default App;